import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoProviders = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--background-complete--inject-1",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					y: 382.4,
					width: 500,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 416.78,
					y: 398.49,
					width: 33.12,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 322.53,
					y: 401.21,
					width: 8.69,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 396.59,
					y: 389.21,
					width: 19.19,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 52.46,
					y: 390.89,
					width: 43.19,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 104.56,
					y: 390.89,
					width: 6.33,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 131.47,
					y: 395.11,
					width: 93.68,
					height: .25,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "363.37 133.85 330.14 114.52 304.54 114.52 270.76 132.93 270.76 258.22 363.37 258.22 363.37 133.85",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M269.8,133.85l1-.92a65.81,65.81,0,0,1,45.82-18.41h0a65.81,65.81,0,0,1,45.82,18.41l1,.92V258.22H269.8Zm87.36,2.66a60,60,0,0,0-81.15,0V252h81.15Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "318.91 252.76 314.26 252.76 314.26 211.18 274.83 211.18 274.83 206.53 314.26 206.53 314.26 164 274.83 164 274.83 159.34 314.26 159.34 314.26 119.92 318.91 119.92 318.91 159.34 358.34 159.34 358.34 164 318.91 164 318.91 206.53 358.34 206.53 358.34 211.18 318.91 211.18 318.91 252.76",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M266.7,132.58l.91-.91a69.35,69.35,0,0,1,97.95,0l.91.91V261.32H266.7Zm93.56,2.59a63.12,63.12,0,0,0-87.35,0v120h87.35Z",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "226.84 133.85 193.61 114.52 168 114.52 134.22 132.93 134.22 258.22 226.84 258.22 226.84 133.85",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M133.27,133.85l.95-.92a65.85,65.85,0,0,1,45.83-18.41h0a65.82,65.82,0,0,1,45.83,18.41l1,.92V258.22H133.27Zm87.36,2.66a60,60,0,0,0-81.15,0V252h81.15Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "182.38 252.76 177.73 252.76 177.73 211.18 138.3 211.18 138.3 206.53 177.73 206.53 177.73 164 138.3 164 138.3 159.34 177.73 159.34 177.73 119.92 182.38 119.92 182.38 159.34 221.81 159.34 221.81 164 182.38 164 182.38 206.53 221.81 206.53 221.81 211.18 182.38 211.18 182.38 252.76",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M130.17,132.58l.91-.91a69.35,69.35,0,0,1,97.95,0l.91.91V261.32H130.17Zm93.56,2.59a63.13,63.13,0,0,0-87.36,0v120h87.36Z",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M404,349.9c0-.35,1.21-35.46,6.92-41,5.55-5.4,11.93-.2,12.19,0l.58-.68c-.08-.07-7.27-5.94-13.4,0-6,5.8-7.13,40.17-7.18,41.63Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M403.54,356.8c0-.42,3.91-42.14-11.33-59.63l-.68.58c15,17.2,11.16,58.55,11.12,59Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M404.11,352.39l.89-.06c0-.47-3-47.44,8.2-57.72l-.61-.66C401.1,304.52,404,350.44,404.11,352.39Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M402.65,352.36h.9c0-1.3-.37-31.73-9-36.68a6.12,6.12,0,0,0-5.59-.55c-5.23,2.17-7.82,11.47-7.92,11.86l.86.24c0-.09,2.58-9.28,7.4-11.27a5.29,5.29,0,0,1,4.81.49C402.29,321.16,402.65,352.05,402.65,352.36Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M406,352.39l.89-.05c0-.24-1.3-24,5.12-32.44,1.56-2,3.25-3,5-2.88,4.21.3,7.74,6.46,7.78,6.52l.78-.44c-.16-.27-3.8-6.64-8.49-7-2.1-.15-4.06.94-5.81,3.23C404.7,328,406,351.4,406,352.39Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M404.61,355.62c.17-2.31,4.2-56.66-2.88-66.24l-.72.53c6.89,9.31,2.75,65.08,2.71,65.65Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M387,320.64s4.25,1.57,3,5.27-14.7,9.78-14.7,9.78-5.62-5.16-.46-13.54S386.9,318,387,320.64Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M405.49,313.6s-4.53-.19-4.79,3.71S410.51,332,410.51,332s7.17-2.59,5.63-12.32S406.61,311.21,405.49,313.6Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M409.32,294.94s-3-.32-2.78-2.16,11.73-6.57,18.5,1.08c0,0-4.34,7.45-10.61,7.55S409.32,294.94,409.32,294.94Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M403.69,290.48s2.74,1.32,3.5-.37-6.48-11.77-16.27-8.87c0,0-.26,8.62,5,12S403.69,290.48,403.69,290.48Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M418,319.16s-2.09-1.68.16-2.5,13.27-.59,13.39,10.33c0,0-12.84,2.13-14.43-2S418,319.16,418,319.16Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M391.8,294.67s2.08-1.69-.17-2.51-13.27-.58-13.39,10.34c0,0,12.84,2.13,14.43-2S391.8,294.67,391.8,294.67Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M398.58,303.46s.19-2-1.46-1.24-7.4,7-1.44,12.88c0,0,8-5.94,6.57-9S398.58,303.46,398.58,303.46Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M419.84,306.37s-1.25-1.63.58-1.83,10,2,8.08,10.13c0,0-9.95-.75-10.37-4.13S419.84,306.37,419.84,306.37Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "386.22 382.63 420.36 382.63 424.05 345.25 382.54 345.25 386.22 382.63",
					style: { fill: "#f0f0f0" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 380.71,
					y: 341.13,
					width: 45.15,
					height: 8.25,
					transform: "translate(806.58 690.5) rotate(180)",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M93.59,349.77l-9.72-28s13.48,10,13.39-1.09-6.14-2.48-8.24-6.57,6-4.05,3.14-10.25-10.89,3.33-12.31-2.17-3.7-8.3-9.56-7.8c0,0-3.18,7.23.71,12.46s-9.61,1-8.24,6.29,5.88,9.85,7.86,6.15,4.51,3.39,1.12,5.22,4.43,9.74,6.15,5.59a43.54,43.54,0,0,1,4.42-7.85l9,30Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M103.61,350l11-17.92s-10.83,4.88-9.1-2.77,4.62-.79,6.7-3.3-3.53-3.71-.63-7.57,7,4,8.85.36,3.81-5.18,7.8-4c0,0,1.1,5.49-2.38,8.52s6.49,2.17,4.75,5.6S125,334.9,124.18,332s-3.63,1.67-1.56,3.44-4.54,6.08-5.1,2.94a31.27,31.27,0,0,0-1.87-6.09l-10.73,19.38Z",
					style: { fill: "#e6e6e6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M96.23,350.19l5-28.86S89.69,333.22,88,322.4s5.59-3.39,7-7.71-6.48-3-4.7-9.5,11.15,1.51,11.66-4.08,2.28-8.67,8.08-9.12c0,0,4.25,6.55,1.29,12.26s9.54-.52,9,4.83-4.17,10.53-6.69,7.24-3.86,4-.26,5.26-2.77,10.21-5.11,6.44a43,43,0,0,0-5.55-6.95l-4,30.64Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M90,382.63h17.23a2.28,2.28,0,0,0,2.27-2.14l1.83-29.71a2.28,2.28,0,0,0-2.28-2.41H88.19a2.27,2.27,0,0,0-2.28,2.41l1.83,29.71A2.28,2.28,0,0,0,90,382.63Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M86.13,351.71h25.2a2.28,2.28,0,0,0,2.27-2h0a2.28,2.28,0,0,0-2.27-2.54H86.13a2.28,2.28,0,0,0-2.27,2.54h0A2.28,2.28,0,0,0,86.13,351.71Z",
					style: { fill: "#f5f5f5" }
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "freepik--Shadow--inject-1",
			children: /* @__PURE__ */ _jsx("ellipse", {
				id: "freepik--path--inject-1",
				cx: 250,
				cy: 416.24,
				rx: 193.89,
				ry: 11.32,
				style: { fill: "#f5f5f5" }
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Chair--inject-1",
			children: [
				/* @__PURE__ */ _jsx("polygon", {
					points: "101.6 276.97 105.42 276.97 116.05 339.36 112.23 339.36 101.6 276.97",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "115.77 276.97 119.59 276.97 130.22 339.36 126.4 339.36 115.77 276.97",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "129.95 276.97 133.76 276.97 144.4 339.36 140.58 339.36 129.95 276.97",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "101.6 276.97 105.42 276.97 116.05 339.36 112.23 339.36 101.6 276.97",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "115.77 276.97 119.59 276.97 130.22 339.36 126.4 339.36 115.77 276.97",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "129.95 276.97 133.76 276.97 144.4 339.36 140.58 339.36 129.95 276.97",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M108.2,284.18c6.14-3.72,14.68-3.72,22.83,0,4.12,1.8,9,2.32,11.16-.29h0c3.68-3.83-2.78-15.18-15.16-18.77-8.86-2.54-17.64-2.54-25.13,0-10.44,3.59-10.76,14.94-5,18.77h0C100.45,286.5,105.05,286,108.2,284.18Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M108.2,284.18c6.14-3.72,14.68-3.72,22.83,0,4.12,1.8,9,2.32,11.16-.29h0c3.68-3.83-2.78-15.18-15.16-18.77-8.86-2.54-17.64-2.54-25.13,0-10.44,3.59-10.76,14.94-5,18.77h0C100.45,286.5,105.05,286,108.2,284.18Z",
					style: {
						fill: "#fff",
						opacity: .7000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M108.75,334.18H168a0,0,0,0,1,0,0v5.93a4.43,4.43,0,0,1-4.43,4.43H113.18a4.43,4.43,0,0,1-4.43-4.43v-5.93A0,0,0,0,1,108.75,334.18Z",
					transform: "translate(276.79 678.72) rotate(180)",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M108.75,334.18H168a0,0,0,0,1,0,0v5.93a4.43,4.43,0,0,1-4.43,4.43H113.18a4.43,4.43,0,0,1-4.43-4.43v-5.93A0,0,0,0,1,108.75,334.18Z",
					transform: "translate(276.79 678.72) rotate(180)",
					style: {
						fill: "#fff",
						opacity: .7000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "134.23 340.97 134.55 354.77 136 417.16 140.79 417.16 142.24 354.77 142.56 340.97 134.23 340.97",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "134.23 340.97 134.55 354.77 136 417.16 140.79 417.16 142.24 354.77 142.56 340.97 134.23 340.97",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "134.23 340.97 134.55 355.15 142.24 355.15 142.56 340.97 134.23 340.97",
					style: {
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "108.2 416.94 112.63 341.95 119.87 341.95 113.67 416.94 108.2 416.94",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "113.68 416.94 108.21 416.94 112.23 348.68 112.63 341.86 119.87 341.86 119.31 348.68 113.68 416.94",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "119.87 341.86 119.31 348.95 112.23 348.95 112.63 341.86 119.87 341.86",
					style: {
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "163.12 416.94 156.92 341.95 164.16 341.95 168.59 416.94 163.12 416.94",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "163.11 416.94 157.48 348.68 156.93 341.86 164.16 341.86 164.56 348.68 168.58 416.94 163.11 416.94",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "156.93 341.86 157.48 348.95 164.56 348.95 164.16 341.86 156.93 341.86",
					style: {
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 105.91,
					y: 339.36,
					width: 64.97,
					height: 5.18,
					rx: 1.78,
					transform: "translate(276.79 683.9) rotate(180)",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 105.91,
					y: 339.36,
					width: 64.97,
					height: 5.18,
					rx: 1.78,
					transform: "translate(276.79 683.9) rotate(180)",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .6000000000000001
					}
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--character-1--inject-1",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M195.45,416.72h1.37l.37-1.69,4.53,2.05h11.45s1.82-1.84-3.63-3.3a3.94,3.94,0,0,1-.78-.29c-2.9-1.37-7-6-7-6h-6.29a7.17,7.17,0,0,0-.51.9C194.23,409.81,193,412.71,195.45,416.72Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M194.92,408.42v0c.83-.92,4.6,3.14,7.37,4.52,2.47,1.23,5.24,1.78,6.47.53-2.9-1.37-7.48-7.32-7.48-7.32h-5.05S195.21,407.83,194.92,408.42Z",
					style: { fill: "#ffc2bc" }
				}),
				/* @__PURE__ */ _jsx("polyline", {
					points: "201.56 406.97 196.29 382.71 187.55 386.24 195.97 407.72",
					style: { fill: "#ffc2bc" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M181.28,265.77s7,42.31,8.17,64.13c1.22,22.93,8.57,59.64,12.46,74-1.1,1-6.24,1.4-8.67.18,0,0-21.2-42.34-18.44-68.81-17.73-49.92-13.45-68.6-13.45-68.6Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("g", {
					style: { opacity: .7000000000000001 },
					children: /* @__PURE__ */ _jsx("path", {
						d: "M181.28,265.77s7,42.31,8.17,64.13c1.22,22.93,8.57,59.64,12.46,74-1.1,1-6.24,1.4-8.67.18,0,0-21.2-42.34-18.44-68.81-17.73-49.92-13.45-68.6-13.45-68.6Z",
						style: { fill: "#fff" }
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M154.53,416.81h1.37l.37-1.69,4.53,2h11.45s1.82-1.83-3.63-3.29a4,4,0,0,1-.78-.3c-2.91-1.36-7-6-7-6h-6.29a8.82,8.82,0,0,0-.52.91C153.31,409.89,152.12,412.8,154.53,416.81Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M154,408.51v0c.83-.93,4.61,3.14,7.38,4.52,2.47,1.23,5.24,1.77,6.47.52-2.91-1.36-7.48-7.31-7.48-7.31h-5.05S154.29,407.92,154,408.51Z",
					style: { fill: "#ffc2bc" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "160.57 407.47 159.99 381.08 150.35 381.77 155.23 407.63 160.57 407.47",
					style: { fill: "#ffc2bc" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M169.55,319.37c-2.53-8.32-4.34-15.52-5.63-21.7,1.28-4.83,3.09-9,5.55-11.45C169.47,286.22,173,299.68,169.55,319.37Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M173.68,263.55s-5.8,44.89-9.12,66.49c-3.5,22.69-3.94,59.09-3.07,73.93-1.27.74-5.9,1.63-8.4.85,0,0-11.83-45.89-4-72.54-7.15-52.49,3.2-65.35,3.2-65.35Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("g", {
					style: { opacity: .7000000000000001 },
					children: /* @__PURE__ */ _jsx("path", {
						d: "M173.68,263.55s-5.8,44.89-9.12,66.49c-3.5,22.69-3.94,59.09-3.07,73.93-1.27.74-5.9,1.63-8.4.85,0,0-11.83-45.89-4-72.54-7.15-52.49,3.2-65.35,3.2-65.35Z",
						style: { fill: "#fff" }
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M168.56,185.42s5.53-.71,8.09,4.29-.7,12.48-.7,12.48-3.51,5.5.09,10c3.17,4-.55,7-7,8.55s-18.72.38-21.89-3.27,2.31-7.14,1.63-14.15-.89-13.64,6.42-17.42C161.13,182.84,165.89,183.63,168.56,185.42Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M209.47,244.29l4.75-5.83,3.82,6.13s-5.33,4.75-7.11,3.41Z",
					style: { fill: "#eec1bb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "220.94 238.2 222.49 243.15 218.04 244.59 214.22 238.47 220.94 238.2",
					style: { fill: "#eec1bb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M180.14,237.21l.05.16a.89.89,0,0,0,0,.14c.11.35.3,1,.59,1.81.08.25.18.51.27.8a0,0,0,0,1,0,0c.07.19.14.4.22.6.34.9.74,1.92,1.22,3,.18.41.37.84.58,1.26s.38.77.58,1.15l.62,1.15s0,0,0,.06.19.33.3.5.2.35.3.52l.27.42c.15.24.32.47.48.71l.12.19c.27.38.55.75.82,1.09s.44.54.67.78.31.34.47.5.43.44.66.64l.45.39.31.24c.15.11.3.23.46.33s.39.25.59.36a6.79,6.79,0,0,0,1.4.64C196.07,256.15,212,249,212,249h0l-1.9-5.35s-14.59,4.6-16,3.22a8.17,8.17,0,0,1-1-1.47c-.17-.28-.34-.61-.51-1l-.19-.36c-.12-.23-.24-.49-.37-.75h0l-.39-.81c-.33-.7-.68-1.47-1-2.26l-.43-1c-.14-.34-.29-.67-.44-1l-.44-1c-2.4-5.5-5-11.6-6.8-13.54a1.37,1.37,0,0,0-.17-.17,1.38,1.38,0,0,0-.73-.44l-1.38,13.6a.08.08,0,0,0,0,0Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M180.14,237.21l.05.16a.39.39,0,0,0,0,.14c.11.35.3,1,.59,1.81.08.25.18.51.27.8a0,0,0,0,1,0,0c.07.19.14.4.22.6.34.9.74,1.92,1.22,3,.18.41.37.84.58,1.26s.38.77.58,1.15l.62,1.15s0,0,0,.06.19.33.3.5h0a25.94,25.94,0,0,0-3.59-14.09,14.23,14.23,0,0,0-.86,3,.08.08,0,0,0,0,0Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M151.09,251.25c.95,6.07,1.46,10.57,1.46,10.57l-1.22,3.55L149.05,272l17.34,5.42,4-10.07,3.29,9.58,10-3-1.74-13.21c2.43-27.3,0-37.46,0-37.46-4.08-2.5-10.3-2.44-10.3-2.44,1.44,7.64-15.42-.72-15.42-.72a42.1,42.1,0,0,0-12.12,3,58.34,58.34,0,0,1,3.77,11.51c.77,3.09,1.44,6.36,2,9.52C150.33,246.6,150.73,249,151.09,251.25Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M157.24,205.53c1.16,4.31,2.59,12.2-.21,15.07,0,0-3.91,3.78,7.46,3.43,1,2.37,4.82,6.72,4.82,6.72s1.73-4.8.94-6.53c7.32-.63.17-3.62.17-3.62-4.89-1.14-5-4.71-4.44-8Z",
					style: { fill: "#eec1bb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M160.8,208.39l5.18,4.15a12.89,12.89,0,0,0-.24,2.38c-1.86-.27-4.53-2.28-4.86-4.2A6.52,6.52,0,0,1,160.8,208.39Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M153.56,196.88c1.31,7,1.71,9.92,5.68,13.26,6,5,14.17,2.36,15-4.73.7-6.38-1.55-16.69-8.72-19A9.06,9.06,0,0,0,153.56,196.88Z",
					style: { fill: "#eec1bb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M159.54,191.86c-3.84,4.95,4.05,10.65-3.84,10.32s-4.68-11.47,0-14S159.54,191.86,159.54,191.86Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M164.58,198c.08.59.46,1,.83,1s.62-.53.53-1.12-.46-1-.83-1S164.49,197.45,164.58,198Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M171.68,197.62c.09.59.46,1,.84,1s.61-.53.53-1.12-.46-1-.84-1S171.6,197,171.68,197.62Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M172.05,196.55l1.33-.51S172.82,197.2,172.05,196.55Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M169.84,198.73a17.84,17.84,0,0,0,2.6,3.61,2.36,2.36,0,0,1-2,.54Z",
					style: { fill: "#d4827d" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M167.44,205.3a6.28,6.28,0,0,0,1,0,.16.16,0,0,0,.14-.19.18.18,0,0,0-.19-.16,4.94,4.94,0,0,1-4-1.55.17.17,0,1,0-.26.21A5.22,5.22,0,0,0,167.44,205.3Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M162.59,194.88a.36.36,0,0,0,.25-.11,2.54,2.54,0,0,1,2.25-.86.31.31,0,0,0,.38-.27.38.38,0,0,0-.3-.41,3.19,3.19,0,0,0-2.86,1.06.36.36,0,0,0,0,.49A.39.39,0,0,0,162.59,194.88Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M173.28,194.24a.32.32,0,0,0,.24-.08.34.34,0,0,0,0-.48,3.64,3.64,0,0,0-2.94-1.31.32.32,0,0,0-.28.38.37.37,0,0,0,.4.3,2.92,2.92,0,0,1,2.32,1.07A.42.42,0,0,0,173.28,194.24Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M165,197l1.32-.51S165.72,197.62,165,197Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M152.88,203.59a4.9,4.9,0,0,0,3,2.59c1.62.43,2.32-1.43,1.78-3.28-.48-1.67-1.91-3.9-3.49-3.5S152.07,202,152.88,203.59Z",
					style: { fill: "#eec1bb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M168.56,189.23s-.83,6.67-12.87,7.23l-1.38-7.23s3.64-6.19,12-4.52,8,10.17,8,10.17A8.88,8.88,0,0,0,168.56,189.23Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M167,218.86s3.75,2.62,3.3,5.36l6.4,1.58S172.87,219.32,167,218.86Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M155.53,226.94l9-2.91s-4.74-3.82-6.22-5.89l-3,2.22h0C155.24,220.53,154.36,222.71,155.53,226.94Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M167,218.86s3.75,2.62,3.3,5.36l6.4,1.58S172.87,219.32,167,218.86Z",
					style: {
						fill: "#fff",
						opacity: .6000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M155.53,226.94l9-2.91s-4.74-3.82-6.22-5.89l-3,2.22h0C155.24,220.53,154.36,222.71,155.53,226.94Z",
					style: {
						fill: "#fff",
						opacity: .6000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M152.55,261.82l-1.22,3.55c2.58,0,5.6-.14,8.47-.3,5.54-.32,10.51-.75,10.51-.75l-.41-6.92-5.55.08-.27-.52a22.63,22.63,0,0,1-3.24-1,98.33,98.33,0,0,1-9.45-4.5l-.3-.16C152,257.32,152.55,261.82,152.55,261.82Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M162.86,258l7.45-1-1.45,7.07s-7.14-.23-7.51-2.43Z",
					style: { fill: "#eec1bb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "175.37 261.46 173.08 266.11 168.86 264.1 170.31 257.02 175.37 261.46",
					style: { fill: "#eec1bb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M147.84,234.59c.77,3.09,1.44,6.36,2,9.52,1.47-4.68.22-10.91.22-10.91A4.27,4.27,0,0,0,147.84,234.59Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M144.06,223.09c-3.33,2.94-9.26,29.5-7.33,32.88s24.45,7.21,24.45,7.21l2.17-5.72s-17.84-4.92-17.84-6.87,3.6-10.34,3.6-10.34,2.41-7-.33-13.31C147.14,223.13,144.06,223.09,144.06,223.09Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "163.35 257.46 160.84 255.91 157.93 263.18 161.18 263.18 163.35 257.46",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "210.06 243.68 207.46 244.1 209.47 251.25 211.96 249.03 210.06 243.68",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "163.35 257.46 160.84 255.91 157.93 263.18 161.18 263.18 163.35 257.46",
					style: {
						fill: "#fff",
						opacity: .6000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "210.06 243.68 207.46 244.1 209.47 251.25 211.96 249.03 210.06 243.68",
					style: {
						fill: "#fff",
						opacity: .6000000000000001
					}
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Table--inject-1",
			children: [
				/* @__PURE__ */ _jsx("polygon", {
					points: "334.55 276.97 330.73 276.97 320.1 339.36 323.92 339.36 334.55 276.97",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "320.37 276.97 316.55 276.97 305.92 339.36 309.74 339.36 320.37 276.97",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "306.2 276.97 302.38 276.97 291.75 339.36 295.57 339.36 306.2 276.97",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "334.55 276.97 330.73 276.97 320.1 339.36 323.92 339.36 334.55 276.97",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "320.37 276.97 316.55 276.97 305.92 339.36 309.74 339.36 320.37 276.97",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "306.2 276.97 302.38 276.97 291.75 339.36 295.57 339.36 306.2 276.97",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M328,284.18c-6.15-3.72-14.68-3.72-22.84,0-4.12,1.8-9,2.32-11.16-.29h0c-3.67-3.83,2.78-15.18,15.16-18.77,8.87-2.54,17.64-2.54,25.13,0,10.44,3.59,10.76,14.94,5,18.77h0C335.69,286.5,331.1,286,328,284.18Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M328,284.18c-6.15-3.72-14.68-3.72-22.84,0-4.12,1.8-9,2.32-11.16-.29h0c-3.67-3.83,2.78-15.18,15.16-18.77,8.87-2.54,17.64-2.54,25.13,0,10.44,3.59,10.76,14.94,5,18.77h0C335.69,286.5,331.1,286,328,284.18Z",
					style: {
						fill: "#fff",
						opacity: .7000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M272.54,334.18H323a4.43,4.43,0,0,1,4.43,4.43v5.93a0,0,0,0,1,0,0H268.11a0,0,0,0,1,0,0v-5.93A4.43,4.43,0,0,1,272.54,334.18Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M272.54,334.18H323a4.43,4.43,0,0,1,4.43,4.43v5.93a0,0,0,0,1,0,0H268.11a0,0,0,0,1,0,0v-5.93A4.43,4.43,0,0,1,272.54,334.18Z",
					style: {
						fill: "#fff",
						opacity: .7000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "301.91 340.97 301.6 354.77 300.14 417.16 295.35 417.16 293.91 354.77 293.59 340.97 301.91 340.97",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "301.91 340.97 301.6 354.77 300.14 417.16 295.35 417.16 293.91 354.77 293.59 340.97 301.91 340.97",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "301.91 340.97 301.6 355.15 293.91 355.15 293.59 340.97 301.91 340.97",
					style: {
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "327.94 416.94 323.51 341.95 316.28 341.95 322.47 416.94 327.94 416.94",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "322.46 416.94 327.93 416.94 323.92 348.68 323.52 341.86 316.28 341.86 316.84 348.68 322.46 416.94",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "316.28 341.86 316.84 348.95 323.92 348.95 323.52 341.86 316.28 341.86",
					style: {
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "273.02 416.94 279.22 341.95 271.98 341.95 267.56 416.94 273.02 416.94",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "273.04 416.94 278.66 348.68 279.22 341.86 271.98 341.86 271.58 348.68 267.56 416.94 273.04 416.94",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "279.22 341.86 278.66 348.95 271.58 348.95 271.98 341.86 279.22 341.86",
					style: {
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 265.27,
					y: 339.36,
					width: 64.97,
					height: 5.18,
					rx: 1.78,
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 265.27,
					y: 339.36,
					width: 64.97,
					height: 5.18,
					rx: 1.78,
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .6000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M251.9,296.31v2.58c0,.67-.78.94-1.43.94H198.91c-.66,0-1.45-.27-1.45-.94v-2.58Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M251.9,296.31v2.58c0,.67-.78.94-1.43.94H198.91c-.66,0-1.45-.27-1.45-.94v-2.58Z",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M251.9,296.31v2.58c0,.67-.78.94-1.43.94h-34c-.66,0-1.45-.27-1.45-.94v-2.58Z",
					style: {
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M260.53,269.53l-6.14,27.84a2.09,2.09,0,0,1-2,1.58H218.87a1.36,1.36,0,0,1-1.26-1.75l6.13-27.63a1.92,1.92,0,0,1,2-1.36h33.52C260.16,268.21,260.73,268.62,260.53,269.53Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M260.53,269.53l-6.14,27.84a2.09,2.09,0,0,1-2,1.58H220a1.35,1.35,0,0,1-1.26-1.75l6.13-27.63a1.92,1.92,0,0,1,2-1.36h32.38C260.16,268.21,260.73,268.62,260.53,269.53Z",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M244,283.68h0c0,2.38-2.56,4.31-4.43,4.31s-3-1.93-2.45-4.31,2.4-4.25,4.23-4.32c-.53,2.39.61,4.32,2.48,4.32Z",
					style: {
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "257.2 417.16 257.93 305.99 250.73 305.99 251.45 417.16 257.2 417.16",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "251.45 417.16 257.2 417.16 257.78 328.11 257.93 306.21 250.72 306.21 250.86 328.11 251.45 417.16",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .4
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "250.72 306.21 250.86 328.36 257.78 328.36 257.93 306.21 250.72 306.21",
					style: {
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "201.19 417.16 209.17 305.99 201.97 305.99 195.44 417.16 201.19 417.16",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "201.19 417.16 208.69 312.73 209.17 306.21 201.97 306.21 201.58 312.73 195.44 417.16 201.19 417.16",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .5
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "201.58 312.41 208.69 312.41 209.17 306.21 201.97 306.21 201.58 312.41",
					style: {
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "313.21 417.16 306.68 305.99 299.48 305.99 307.47 417.16 313.21 417.16",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "307.47 417.16 313.21 417.16 307.07 312.73 306.68 306.21 299.48 306.21 299.96 312.73 307.47 417.16",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .5
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "306.68 306.21 299.48 306.21 299.96 312.41 307.07 312.41 306.68 306.21",
					style: {
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M198.18,302.59H310.47a1.92,1.92,0,0,1,1.92,1.92v4.88a0,0,0,0,1,0,0H196.26a0,0,0,0,1,0,0v-4.88A1.92,1.92,0,0,1,198.18,302.59Z",
					transform: "translate(508.65 611.98) rotate(180)",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M198.18,302.59H310.47a1.92,1.92,0,0,1,1.92,1.92v4.88a0,0,0,0,1,0,0H196.26a0,0,0,0,1,0,0v-4.88A1.92,1.92,0,0,1,198.18,302.59Z",
					transform: "translate(508.65 611.98) rotate(180)",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .6000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 196.26,
					y: 302.59,
					width: 116.12,
					height: 3.4,
					transform: "translate(508.65 608.58) rotate(180)",
					style: {
						isolation: "isolate",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M192.9,303.48H315.75a1.92,1.92,0,0,0,1.92-1.92h0a1.91,1.91,0,0,0-1.92-1.91H192.9a1.91,1.91,0,0,0-1.92,1.91h0A1.92,1.92,0,0,0,192.9,303.48Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M192.9,303.48H315.75a1.92,1.92,0,0,0,1.92-1.92h0a1.91,1.91,0,0,0-1.92-1.91H192.9a1.91,1.91,0,0,0-1.92,1.91h0A1.92,1.92,0,0,0,192.9,303.48Z",
					style: {
						fill: "#fff",
						isolation: "isolate",
						opacity: .6000000000000001
					}
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--character-2--inject-1",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M379.57,208.64c2.59,10.62,5.31,21.12,6.09,32.13a162.62,162.62,0,0,1-2.94,25.11l-4.84-.31c-.57-7.91-.51-16.49-1-24.37-.76-5.54-2.27-10.94-3.56-16.53L370.07,211l9.5-2.37Z",
					style: { fill: "#e4897b" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "382.1 279.87 374.57 278.41 375.48 271.82 384.67 273.07 382.1 279.87",
					style: { fill: "#e4897b" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M383,264.73l1.67,8.34-9.19-1.25s-.05-7.62,3.4-8.46Z",
					style: { fill: "#e4897b" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M389.93,269.69l-.57-14.05a2.81,2.81,0,0,0-2.79-2.66H361.79a.92.92,0,0,0-.93,1l.64,15.75Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M388.21,287h-26.5a1,1,0,0,1-1-1l-1.3-32.11a.92.92,0,0,1,.93-1h26.49a1,1,0,0,1,1,1l1.3,32.11A.91.91,0,0,1,388.21,287Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M387.83,253.93l1.31,32.12a.93.93,0,0,1-.93,1H361.72a1,1,0,0,1-1-1l-1.31-32.12a.91.91,0,0,1,.93-1h26.49A1,1,0,0,1,387.83,253.93Z",
					style: {
						fill: "#fff",
						opacity: .2
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M387.31,257h-2.39a.92.92,0,0,1-.91-.87l0-.64a.86.86,0,0,1,.24-.63.84.84,0,0,1,.62-.26h2.39a.92.92,0,0,1,.91.87l0,.64a.84.84,0,0,1-.24.62A.85.85,0,0,1,387.31,257Zm-2.47-1.9a.36.36,0,0,0-.26.11.35.35,0,0,0-.1.26l0,.64a.42.42,0,0,0,.41.39h2.39a.36.36,0,0,0,.26-.11.35.35,0,0,0,.1-.26l0-.64a.41.41,0,0,0-.41-.39Z",
					style: { fill: "#fff" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "387.46 257.5 384.85 257.5 384.81 256.36 387.42 256.36 387.46 257.5",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M382.83,253.93l1.31,32.12a.93.93,0,0,1-.93,1H361.72a1,1,0,0,1-1-1l-1.31-32.12a.91.91,0,0,1,.93-1h21.49A1,1,0,0,1,382.83,253.93Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M344.94,174.88c0,.55-.31,1-.67,1s-.64-.45-.63-1,.31-1,.67-1S345,174.33,344.94,174.88Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M344.68,175.87a19.89,19.89,0,0,1-2.71,4.66,3.19,3.19,0,0,0,2.62.54Z",
					style: { fill: "#de5753" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M347,171.86a.32.32,0,0,0,.2-.12.33.33,0,0,0-.06-.46,3.22,3.22,0,0,0-2.9-.55.32.32,0,0,0-.19.42.32.32,0,0,0,.41.19h0a2.56,2.56,0,0,1,2.29.46A.28.28,0,0,0,347,171.86Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M362,180.76c-1.3,4.91-2.88,14,.39,17.52,0,0-1.7,5-10.95,4.35-10.17-.67-4.53-5.37-4.53-5.37,5.64-1,5.77-5.09,5.06-9Z",
					style: { fill: "#e4897b" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M363.31,174.05c-.54,6.75-.51,10.73-4,14.13-5.23,5.12-13.51,1.87-15-4.9-1.34-6.1-.23-16.11,6.43-18.67A9.23,9.23,0,0,1,363.31,174.05Z",
					style: { fill: "#e4897b" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M362.29,185.08c-2.45,2.07-13.38-1.32-12.79-9.63,0,0-4.64-3.87-5.14-9s2.61-7.68,6.48-7.28c3.42.36,3.66,2.15,3.66,2.15s15.66-1,13.53,5.82C375.53,172.81,365.34,182.5,362.29,185.08Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M352.42,176.33a7.71,7.71,0,0,1-2,4.51c-1.51,1.62-3.05.58-3.29-1.42-.21-1.8.31-4.81,2.14-5.69S352.56,174.31,352.42,176.33Z",
					style: { fill: "#e4897b" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M363.8,197.48l-.46-3.36S347,193,344.68,197.48,360.74,201.38,363.8,197.48Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M363.8,197.48l-.46-3.36S347,193,344.68,197.48,360.74,201.38,363.8,197.48Z",
					style: {
						fill: "#fff",
						opacity: .5
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M367.24,212.78l.89,2.32L373.08,228l.18.45,12-4.91s-5.57-23.69-10.71-24.68Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M367.24,212.78l.89,2.32L373.08,228l.18.45,12-4.91s-5.57-23.69-10.71-24.68Z",
					style: {
						fill: "#fff",
						opacity: .7000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M368.13,215.1,373.08,228c4.95-10.88-.73-20.68-.73-20.68C370.89,208.52,369.39,211.5,368.13,215.1Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M394.07,408.84a.18.18,0,0,0,.1-.15.21.21,0,0,0-.1-.15c-.09,0-2.21-.9-3.13-.46a.77.77,0,0,0-.42.48.66.66,0,0,0,.16.75,2.19,2.19,0,0,0,1.7.09A9.16,9.16,0,0,0,394.07,408.84Zm-.49-.14c-1,.39-2.32.67-2.69.36,0,0-.14-.12-.06-.41a.49.49,0,0,1,.25-.28l.19-.06A5.34,5.34,0,0,1,393.58,408.7Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M394.12,408.81a.17.17,0,0,0,0-.16c0-.08-.6-2-1.51-2.44a.91.91,0,0,0-.72-.06.52.52,0,0,0-.41.53c0,.77,1.67,1.94,2.44,2.17H394Zm-1.62-2.31a3.85,3.85,0,0,1,1.24,1.92c-.8-.38-1.89-1.29-1.9-1.75,0,0,0-.14.2-.21l.07,0A.54.54,0,0,1,392.5,406.5Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M344.11,410.35a.16.16,0,0,0,.13-.13.15.15,0,0,0-.08-.16c-.1-.06-2.49-1.42-3.62-1.11a.75.75,0,0,0-.51.38.59.59,0,0,0,0,.7c.29.4,1.13.52,2,.52A11.6,11.6,0,0,0,344.11,410.35Zm-.53-.23c-1.26.17-3,.16-3.31-.28,0,0-.08-.15,0-.35a.44.44,0,0,1,.31-.23,1.55,1.55,0,0,1,.31,0A7.18,7.18,0,0,1,343.58,410.12Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M344.17,410.33a.18.18,0,0,0,.07-.15,4.64,4.64,0,0,0-1.06-2.63,1.19,1.19,0,0,0-.9-.27c-.44,0-.57.27-.6.45-.12.77,1.51,2.24,2.33,2.61l.07,0A.16.16,0,0,0,344.17,410.33ZM343,407.8a3.75,3.75,0,0,1,.9,2.11c-.84-.51-1.94-1.67-1.87-2.13,0,0,0-.15.32-.18h.09A.85.85,0,0,1,343,407.8Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "351.58 410.2 344.76 410.2 344.08 394.4 350.9 394.4 351.58 410.2",
					style: { fill: "#e4897b" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "401.64 407.04 394.98 408.48 388.28 393.77 394.95 392.33 401.64 407.04",
					style: { fill: "#e4897b" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M394.33,407.81l7.49-1.62a.6.6,0,0,1,.67.33l2.6,5.64a1,1,0,0,1-.72,1.4c-2.62.52-3.93.64-7.22,1.36-2,.44-6.6,1.55-9.4,2.16S384,415,385.08,414.5c4.89-2.24,6.94-4.21,8.26-6A1.71,1.71,0,0,1,394.33,407.81Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M344.8,409.41h7.45a.59.59,0,0,1,.58.46l1.35,6.07a1,1,0,0,1-1,1.21c-2.69,0-6.57-.2-9.95-.2-3.95,0-7.36.21-12,.21-2.8,0-3.58-2.83-2.41-3.09,5.34-1.16,9.7-1.29,14.31-4.13A3.13,3.13,0,0,1,344.8,409.41Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "344.08 394.4 344.43 402.55 351.25 402.55 350.9 394.4 344.08 394.4",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "394.95 392.33 388.28 393.77 391.74 401.36 398.41 399.91 394.95 392.33",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M347.67,249.24s7.74,50,12,68.73c4.65,20.51,29.61,88.37,29.61,88.37l12.21-2.53s-17.45-55.3-21.36-84c-3-22-8.91-70.59-8.91-70.59Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M352.56,267.05c8.95,1.69,8,33.7,6.93,50.17-2.58-11.64-6.36-34-8.94-49.93A3.14,3.14,0,0,1,352.56,267.05Z",
					style: { opacity: .30000000000000004 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M334.73,249.24s-.94,48.92-.2,68.87c.77,20.75,8.33,88.7,8.33,88.7h11.55s.43-66.74.94-87.12c.56-22.22,3.36-70.45,3.36-70.45Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M332.42,228.7c.35,7.69,1,16.31,2.23,25.19l37-1.12s-.37-31.18,2.93-53.87c0,0-24.7-4.54-42.06-.31,0,0-.35,5.1-.41,13.29C332.07,216.58,332.14,222.32,332.42,228.7Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", { points: "372.13 253.46 370.83 253.5 371.04 256.39 372.35 256.35 372.13 253.46" }),
				/* @__PURE__ */ _jsx("polygon", { points: "369.5 253.55 358.38 253.9 358.6 256.8 369.69 256.44 369.5 253.55" }),
				/* @__PURE__ */ _jsx("polygon", { points: "357.05 253.94 342 254.41 342.2 257.34 357.25 256.84 357.05 253.94" }),
				/* @__PURE__ */ _jsx("polygon", { points: "334.24 254.66 334.24 257.6 340.87 257.39 340.67 254.45 334.24 254.66" }),
				/* @__PURE__ */ _jsx("path", {
					d: "M332.42,228.7c.35,7.69,1,16.31,2.23,25.19l37-1.12s-.37-31.18,2.93-53.87c0,0-24.7-4.54-42.06-.31,0,0-.35,5.1-.41,13.29C332.07,216.58,332.14,222.32,332.42,228.7Z",
					style: {
						fill: "#fff",
						opacity: .7000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M332.42,228.7c6.08-7.16,7.58-18.88,7.58-18.88a17.22,17.22,0,0,0-7.9,2.06C332.07,216.58,332.14,222.32,332.42,228.7Z",
					style: { opacity: .2 }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M337.88,206.94c-2.8,6.79-10.19,25.46-18.59,25.58-9.69-.77-15.35-16-17-24.08L307,207a76.08,76.08,0,0,0,6.4,10.9c1.88,2.47,3.74,4.92,6.52,5.9l.1,0a2.8,2.8,0,0,0-1.73-.07c4.34-5.46,7.53-13.6,10.51-20.39l9.11,3.58Z",
					style: { fill: "#e4897b" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "304.8 193.85 297.57 196.39 299.43 202.78 308.34 200.2 304.8 193.85",
					style: { fill: "#e4897b" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M307.91,208.69l.43-8.49-8.91,2.58s1.07,7.54,4.6,7.88Z",
					style: { fill: "#e4897b" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M332.51,198.59c-4.56,1.32-12.9,21.32-12.9,21.32L331.15,227s9.72-11.13,9.72-17.05C340.87,199.27,332.51,198.59,332.51,198.59Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M332.51,198.59c-4.56,1.32-12.9,21.32-12.9,21.32L331.15,227s9.72-11.13,9.72-17.05C340.87,199.27,332.51,198.59,332.51,198.59Z",
					style: {
						fill: "#fff",
						opacity: .7000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M387.48,255c-1.26-6.34-11-54.6-14.3-56.48l-2.91-.23c1.79,1.72,2.19,3.14,14.49,57.4h2.15A.58.58,0,0,0,387.48,255Z",
					style: { fill: "#263238" }
				})
			]
		})
	]
});
export default SvgNoProviders;
